import "./SnippetCard.css";
import { Snippet } from "winslow-core";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSidebarSnippet,
  selectUIStates,
  setOnDiscardConfirm,
  setSidebarSnippet,
  setUIStates,
} from "../../redux/features/appData";

const TITLE_CHARS = 40;
const BODY_CHARS = 40;

type SnippetCardProps = {
  snippet: Snippet;
  selected: boolean;
};

export const SnippetCard = ({ snippet, selected }: SnippetCardProps) => {
  const dispatch = useDispatch();

  const uiStates = useSelector(selectUIStates);
  const sidebarSnippet = useSelector(selectSidebarSnippet);

  let shortAnswer = snippet.answer.substring(0, BODY_CHARS);
  if (shortAnswer.length < snippet.answer.length) {
    shortAnswer += "...";
  }

  let shortTitle = snippet.name.substring(0, TITLE_CHARS);
  if (shortTitle.length < snippet.name.length) {
    shortTitle += "...";
  }

  const handleSelect = () => {
    console.log("[SnippetCard/handleSelect] selected: ", snippet);
    dispatch(setSidebarSnippet({ ...snippet }));
    dispatch(
      setUIStates({
        ...uiStates,
        snippetSidebarOpen: true,
        snippetEdited: false,
      })
    );
  };

  return (
    <>
      <div
        id="snippet-card"
        style={selected ? { borderColor: "var(--highlight-color)" } : {}}
        onClick={() => {
          // do nothing if already selected
          if (selected) {
            return;
          }

          if (uiStates.snippetEdited) {
            dispatch(setOnDiscardConfirm(handleSelect));
            dispatch(
              setUIStates({
                ...uiStates,
                confirmDiscardSnippetOpen: true,
              })
            );
          } else {
            handleSelect();
          }
        }}>
        <div className="snippet-card-title">{shortTitle}</div>
        {/* <div className="snippet-card-snippet">
                    {shortAnswer}
                </div> */}
      </div>
    </>
  );
};
